import React from "react";
import styled, { css } from "styled-components";
import ArrowIncrement from "../../Common/svg/arrowicrement";
import ArrowDecrement from "../../Common/svg/arrowdecrement";

// Styled Components
const Card = styled.div`
position : relative ;
  margin-bottom: 2rem;
  border-radius: 1rem;
  padding: 24px;
  background-color: #fff !important;
  border: 1px solid ${(props) => props.color || "transparent"};
  


`;

const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: ${(props) => props.bgIcon || "#eee"};
  width: 40px;
  height: 40px;
`;

const TextWrapper = styled.div`
  text-align: start;

  .title {
    font-weight: bold;
    color: #000;
    margin-bottom: 0.25rem;
    white-space:noWrap;
  }

  .count {
    color: #6c757d;
    ${(props) =>
      props.isLoading &&
      css`
        background-color: #e0e0e0;
        color: transparent;
        border-radius: 4px;
        width: 80px;
        height: 1em;
      `}
  }

  .rate {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: ${(props) =>
      props.type === "increment"
        ? "green"
        : props.type === "decrement"
        ? "red"
        : "inherit"};
  }
`;

const StatsCard = ({
  title,
  count,
  color = "",
  icon,
  bgIcon,
  home,
  type,
  rate,
  isLoading,
}) => {
    console.log('bgIcon', bgIcon ,color)
  return (
  
    <Card color={color}>
      <CardContent>
        <IconWrapper bgIcon={bgIcon}>{icon}</IconWrapper>
        <TextWrapper isLoading={isLoading} type={type}>
          <div className="title">{title}</div>
          <div className="count">{count}</div>
          {home && (
            <div className="rate">
              {rate}{" "}
              {type === "increment" ? (
                <ArrowIncrement />
              ) : type === "decrement" ? (
                <ArrowDecrement />
              ) : (
                ""
              )}
            </div>
          )}
        </TextWrapper>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
